import * as egm96 from 'egm96-universal'
import {toast} from 'vue3-toastify'

export default class Map_Model3d {
  viewer;
  datasource;
  infosmodel;

  constructor(viewer) {
    this.viewer = viewer;
    this.datasource = undefined;
    this.init();
  }

  init() {
    this.datasource = new Cesium.CustomDataSource("MapModels3d");
    this.viewer.dataSources.add(this.datasource);
    this.infosmodel = undefined;
  }

  clear() {
    this.datasource.entities.removeAll();
    //this.datasource._primitives.removeAll();
    this.infosmodel = undefined;
  }

  async add(url,id, isVisible, callBack, error) {
    const tileset = this.getFromId(id);

    if(!Cesium.defined(tileset)) {
      try {
        await Cesium.Cesium3DTileset.fromUrl(
          url
        ).then(async (tileset) => {
          this.datasource._primitives.add(tileset);
          tileset.show= isVisible;
          tileset.id = id;
          if(callBack) {
            callBack();
          }
        });
      } catch (err) {
        error(err)
      }
    }
}

  setVisibility(id, isVisible) {
    const primitive = this.getFromId(id);
    if(Cesium.defined(primitive)) {
      primitive.show = isVisible;
    }
  }

  remove(id) {
    const tileset = this.getFromId(id);
    if(Cesium.defined(tileset)) {
      this.datasource._primitives.remove(tileset);
    }
  }

  getegm96Alt(cartographic) {
    const egm96Alt = egm96.ellipsoidToEgm96(
      Cesium.Math.toDegrees(cartographic.latitude),
      Cesium.Math.toDegrees(cartographic.longitude),
      0
    );
    return egm96Alt;
  }

  toemg96(id) {
    const tileset = this.getFromId(id);
    if (tileset !== undefined && tileset.boundingSphere !== undefined) {
      const origin = tileset.boundingSphere.center.clone();
      const cartographic = Cesium.Cartographic.fromCartesian(origin);
      if (Cesium.defined(cartographic)) {

        const transEgm = this.getegm96Alt(cartographic);

        const surface = Cesium.Cartesian3.fromRadians(
          cartographic.longitude,
          cartographic.latitude,
          0.0,
        );

        const cartesianoffset = Cesium.Cartesian3.fromRadians(
          cartographic.longitude,
          cartographic.latitude,
          - transEgm,
        );

        const translation = Cesium.Cartesian3.subtract(
          cartesianoffset,
          surface,
          new Cesium.Cartesian3(),
        );
        tileset.root.transform = Cesium.Matrix4.fromTranslation(translation);

      }
    }

  }

  toWGS84(id) {
    const tileset = this.getFromId(id);
    if (tileset !== undefined) {
      tileset.root.transform = Cesium.Matrix4.IDENTITY;
    }
  }

  setQuality(id, quality) {
    let tileset = this.getFromId(id);

    if(Cesium.defined(tileset)) {
      if(quality == 0) {
        tileset.maximumScreenSpaceError = 12;
      }
      else if(quality == 1) {
        tileset.maximumScreenSpaceError = 8;
      }
      else if(quality == 2) {
        tileset.maximumScreenSpaceError = 4;
      }
      else if(quality == 3) {
        tileset.maximumScreenSpaceError = 2;
      }
    }
  }

  getQuality(id) {
    let tileset = this.getFromId(id);
    if(Cesium.defined(tileset)) {
      if(tileset.maximumScreenSpaceError == 12) {
        return 0;
      }
      else if(tileset.maximumScreenSpaceError == 8) {
        return 1;
      }
      else if(tileset.maximumScreenSpaceError == 4) {
        return 2;
      }
      else if(tileset.maximumScreenSpaceError == 2) {
        return 3;
      }
    }

    return 0;
  }

  getFromUrl(url) {
    for(let i=0; i< this.datasource._primitives.length; i++) {
      const primitive = this.datasource._primitives.get(i);
      if(primitive._url == url) {
        return primitive;
      }
    }
    return undefined;
  }

  getFromId(id) {
    for(let i=0; i< this.datasource._primitives.length; i++) {
      const primitive = this.datasource._primitives.get(i);
      if(primitive.id == id) {
        return primitive;
      }
    }
    return undefined;
  }

  getFirst() {
    for(let i=0; i< this.datasource._primitives.length; i++) {
      const primitive = this.datasource._primitives.get(i);
        if(primitive._url != undefined) {
          return primitive;
        }
    }
    return undefined;
  }

  isVisible() {
    return this.getFirst() && this.getFirst().show ==true;
  }

  zoomTo(id){
    const tileset = this.getFromId(id);
    if(Cesium.defined(tileset)) {
      this.viewer.flyTo(tileset);
    }
  }

  refresh() {
    const models = this.getListModel();
    this.resetModels(models);
    return models;
  }

  getListModel() {
    let models = [];
    if (
      $root?.global?.site?.sit_mod3d !== undefined &&
      $root?.global?.site?.sit_mod3d !== null &&
      $root?.global?.site?.sit_mod3d?.length > 0
    ) {

      $root.global.site.sit_mod3d.forEach((infosMod, id) => {
        models.push({
          id: id,
          name: infosMod.name.trim(),
          url: infosMod.url !== null && infosMod.url !== undefined ? infosMod.url.trim() : '',
          proj: infosMod.proj !== null && infosMod.proj !== undefined ? infosMod.proj : 'wgs',
          show: infosMod.show !== null && infosMod.show !== undefined ? infosMod.show : false,
          idxOptions: infosMod.idxOptions !== null && infosMod.idxOptions !== undefined ? infosMod.idxOptions : 0,
          s3: infosMod.s3 !== null && infosMod.s3 !== undefined ? infosMod.s3 : false,
          s3Url: infosMod.s3Url !== null && infosMod.s3Url !== undefined ? infosMod.s3Url : '',
        });
      });
    }
    models = this.decodeListModel(models);
    return models;
  }

  encodeListModel(models) {
    let newlistmodel = [];
    models.forEach((infosMod) => {
      if (infosMod?.s3 == undefined) {
        infosMod.s3 = false;
      }

      newlistmodel.push({
        name : encodeURIComponent(infosMod.name),
        url : encodeURIComponent(infosMod.url),
        proj : infosMod.proj,
        show : infosMod.show,
        idxOptions: infosMod.idxOptions,
        s3: infosMod.s3,
        s3Url: infosMod.s3Url,
      });
    });

    return newlistmodel;
  }

  decodeListModel(models) {
    models.forEach((infosMod) => {
      infosMod.url = decodeURIComponent(infosMod.url);
      infosMod.name = decodeURIComponent(infosMod.name);
    });
    return models;
  }

  resetModels(models){
    this.clear();
    this.infosmodel = models;
    models.forEach((model) => {
      if (model.url !== undefined && model.url !== null && model.url !=="") {
        this.add_model3D(model);
      }
      else
        return;
    });
  }

  add_model3D(infosModel) {
    if (
      infosModel.url == '' ||
      infosModel.url == undefined ||
      infosModel.url == null ||
      infosModel.url == 'null'
    ) {
      return;
    }

    const tileset = this.getFromId(infosModel.url);


    if(Cesium.defined(tileset)) {
      this.setOptions(infosModel);
    }
    else {
      if(infosModel.s3) {
        infosModel.url = window.location.origin + infosModel.s3Url;
      }

      // on ajoute dans Cesium le 3dtiles
      this.add(
        infosModel.url,
        infosModel.id,
        infosModel.show,
        () => {
          // appliquer la reprojection pour que le modèle apparaisse au-dessus du terrain
          this.setOptions(infosModel);
        },
        (err) => {
          toast.error("Erreur du chargement : " + err, $root.toastConfig);
        }
      );
    }
  }

  setOptions(infosModel) {
    this.setQuality(infosModel.id, infosModel.idxOptions);
    this.setVisibility(infosModel.id,infosModel.show);
    if(infosModel.proj === 'egm') {
      this.toemg96(infosModel.id);
    }
    else{
      this.toWGS84(infosModel.id);
    }
  }
}
